
define('text!modules/audiences/segments/behavior/templates/columnSelector.html',[],function () { return '{{#columns}}\n<strand-list-item class="column-selector-item">\n  <strand-checkbox checked class="column-selector-checkbox" id="{{id}}">\n    <label>{{name}}</label>\n  </strand-checkbox>\n</strand-list-item>\n{{/columns}}\n';});

